export type ConditionalValidationOperator = "All" | "Any" | "None";
